import { gql } from "@apollo/client";
import moment from "moment";

const SAVE_VISITA_OTROS_PROFESIONALES_FINALIZAR = gql`
  mutation saveFinalizarVisitaOtrosProfesionales($input: AddVisitaOtrosProfesionalesFinalizarInput!) {
    saveFinalizarVisitaOtrosProfesionales(input: $input) {
      idVisita
    }
  }
`;

export default SAVE_VISITA_OTROS_PROFESIONALES_FINALIZAR;

export const adaptAddVisitaOtrosProfesionalesFinalizarInput = (data, finalizada, latitud, longitud) => ({
  idVisita: data?.idVisita,
  idComboVisitaValorPacienteDomicilio: data?.idComboVisitaValorPacienteDomicilio,
  fechaVisita: moment(data?.fechaVisita).isValid() ? moment(data?.fechaVisita).format("YYYY-MM-DD HH:mm:ss") : null,
  fechaFin: moment(data?.fechaFin).isValid() && !!data?.fechaFin ? moment(data?.fechaFin).format("YYYY-MM-DD HH:mm:ss") : null,
  tiempoEspera: data?.tiempoEspera,
  evolucion: data?.evolucion,
  explicacion: data?.explicacion,
  conformidad: !!data?.conformidad,
  obsConformidad: data?.obsConformidad,
  idComboVisitaValorInterlocutor: data?.idComboVisitaValorInterlocutor,
  nombreCompleto: data?.nombreCompleto,
  codigoAtencion: data?.codigoAtencion,
  dni: data?.dNI?.toString(),
  email: data?.email,
  kinesioRespiratoria: !!data?.kinesioRespiratoria,
  kinesioMotora: !!data?.kinesioMotora,
  finalizada: !!finalizada,
  latitud: latitud?.toString(),
  longitud: longitud?.toString(),
  desdeCoordinacion: !!data?.desdeCoordinacion
});